import { useState } from "react";
import AddCommentModal from "./AddCommentModal";
import CheckIcon from "@mui/icons-material/Check";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import { StopNew } from "../../../ducks/data/route-with-stops/types";

const AddCommentModalAndButton = (input: { stop: StopNew }) => {
  const { stop } = input;
  const [showAddNoteDialog, setShowAddNoteDialog] = useState(false);
  const { t } = useTranslation(["stopPage"]);

  return (
    <>
      {showAddNoteDialog && (
        <AddCommentModal
          stop={stop}
          onClose={() => setShowAddNoteDialog(false)}
        />
      )}
      <Button
        onClick={() => setShowAddNoteDialog(true)}
        variant="outlined"
        size="large"
        startIcon={<EditNoteOutlinedIcon />}
      >
        {t("stopPage:addNote")}
        {stop.comments.length ? <CheckIcon /> : null}
      </Button>
    </>
  );
};

export default AddCommentModalAndButton;
